import { Dimentions } from "Types/Reducers";
import { dimensions as actions } from "actions";

const initialState = {
   width: window.innerWidth,
   height: window.innerHeight,
};

function dimentions(state = initialState, { type, payload }: { type: typeof actions[keyof typeof actions]; payload: any }): Dimentions {
   switch (type) {
      case actions.sync:
         return {
            width: payload.width,
            height: payload.height,
         };
      default:
         return state;
   }
}

export { actions };
export { dimentions };
